module.exports = __webpack_public_path__ + "c94f5546bc40bf79144f1c36035c2d21.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/Slideshow_09.jpg
// module id = 629
// module chunks = 0